import { Modal } from 'antd';
import { ModalStateContext } from '~/contextAPI/modalContext';
import React, { useContext } from 'react';

const FlexModal = () => {
  const { setModalState, modalState } = useContext(ModalStateContext);
  const {
    title,
    width,
    style,
    state,
    closable,
    component,
    className,
    isCenter = true,
  } = modalState;

  const handleCloseModal = () => {
    setModalState((modal) => ({
      ...modal,
      state: false,
    }));
  };
  return (
    <Modal
      title={title}
      footer={null}
      style={style}
      onOk={() => {}}
      visible={state}
      closable={closable}
      maskClosable={false}
      centered={isCenter}
      className={className}
      onCancel={handleCloseModal}
      width={width ? width : '300px'}
    >
      {component}
    </Modal>
  );
};

export default React.memo(FlexModal);
